import React from 'react';
import ReactDOM from 'react-dom/client';

import { RosterPage } from './RosterPage';
import type { RosterPageData } from './types';

function initRosterComponent() {
    const container = document.getElementById('roster-root');
    const pageDataEl = document.getElementById('pageData');
    if (!container || !pageDataEl) { return; }

    const pageData: RosterPageData = JSON.parse(pageDataEl.textContent || '{}');
    const root = ReactDOM.createRoot(container);
    root.render(React.createElement(RosterPage, pageData));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRosterComponent);
} else {
    initRosterComponent();
}

if (module.hot) { module.hot.accept(); }
